export default "<ion-app>\r\n  <ion-router-outlet [swipeGesture]=\"false\"></ion-router-outlet>\r\n</ion-app>";